import { Directive, InjectionToken, Injector, OnDestroy } from '@angular/core';
import { IDataFieldModel } from '@fi-app/data-field/data-field';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { Subject } from 'rxjs';
import { ILightWeightObject } from '@fi-shared/models';

export const DataFieldEdit_DataField = new InjectionToken<IDataFieldModel>('DataFieldEdit_DataField');
export const DataFieldEdit_DataFieldObject = new InjectionToken<any>('DataFieldEdit_DataFieldObject');

@Directive()
export abstract class DataFieldEditBase extends FiComponentsContainer implements OnDestroy {
    public dataField: IDataFieldModel;
    public dataFieldObject: any;

    constructor(protected injector: Injector) {
        super();

        this.dataField = injector.get(DataFieldEdit_DataField);
        this.dataFieldObject = injector.get(DataFieldEdit_DataFieldObject);
    }

    public isSetRequired() {
        return this.dataField.CanSwitchRequired && this.dataField.IsSetRequired;
    }

    getOptionTextClass(item: ILightWeightObject): string {
        return item?.IsSystemObject ? 'color-red' : '';
    }

    protected ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
